// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2l9QC","content":"styles_content__Ma-sT","selectAll":"styles_selectAll__3aONN"};